// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import './bootstrap'
import '../css/app.scss'

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { createPinia } from 'pinia'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createHead } from '@vueuse/head'
import { ZiggyVue } from 'ziggy-js'
import * as Sentry from '@sentry/vue'
// PrimeVue Theme
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
// Directives
import Ripple from 'primevue/ripple'
import Tooltip from 'primevue/tooltip'
import OverlayBadge from 'primevue/overlaybadge'
import StyleClass from 'primevue/styleclass'

const appName = import.meta.env.VITE_APP_NAME || 'Docu-Vault'
const pinia = createPinia()
const head = createHead()

createInertiaApp({
    title: (title) => `${title} | ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })

        const APP_URL = import.meta.env.VITE_APP_URL
        const APP_ENV = import.meta.env.VITE_APP_ENV
        const SENTRY_DSN = import.meta.env.VITE_SENTRY_LARAVEL_DSN
        if (APP_URL && APP_ENV && SENTRY_DSN) {
            Sentry.init({
                app: app,
                dsn: SENTRY_DSN,
                integrations: [
                    Sentry.replayIntegration({
                        maskAllText: false,
                        blockAllMedia: false,
                    }),
                    Sentry.captureConsoleIntegration({
                        levels: ['error']
                    }),
                    Sentry.feedbackIntegration({
                        colorScheme: 'system',
                        autoInject: false,
                    }),
                ],
                environment: APP_ENV,
                tracesSampleRate: 1.0,
                tracePropagationTargets: [`${APP_URL}`],
                replaysSessionSampleRate: 1.0,
                replaysOnErrorSampleRate: 1.0,

            })
        }

        app.use(ZiggyVue)
            .use(plugin)
            .use(head)
            .use(PrimeVue, {
                ripple: true,
                theme: {
                    preset: Aura,
                    options: {
                        darkModeSelector: '.docu-vault-dark',
                    },
                },
            })
            .use(ConfirmationService)
            .use(ToastService)
            .use(pinia)
            .directive('ripple', Ripple)
            .directive('badge', OverlayBadge)
            .directive('styleclass', StyleClass)
            .directive('tooltip', Tooltip)
            .mount(el)
        return app
    },
    progress: {
        color: '#4B5563',
    },
})
